import { ensureSuccess } from './errors';

export type HttpMethod = 'get' | 'post' | 'put' | 'patch' | 'delete';

export interface HttpRequestOptions {
  headers?: Record<string, string>;
  body?: unknown;
  query?: Record<string, unknown>;
}

export interface RawHttpResponse<T = unknown> {
  status: number;
  data: T;
}

export type RawHttpClient = <TResponse = unknown>(
  url: string,
  method: HttpMethod,
  options?: HttpRequestOptions,
) => Promise<RawHttpResponse<TResponse>>;

export interface HttpClient {
  <TResponse = unknown>(
    url: string,
    method: HttpMethod,
    options?: HttpRequestOptions,
  ): Promise<TResponse>;
}

export function createHttpClientFromRaw(rawClient: RawHttpClient): HttpClient {
  return async <TResponse>(
    url: string,
    method: HttpMethod,
    options?: HttpRequestOptions,
  ): Promise<TResponse> => {
    const response = await rawClient<TResponse>(url, method, options);
    const successfulResponse = ensureSuccess(url, method, response);
    return successfulResponse.data;
  };
}
